import { memo, useEffect, useRef, useState } from 'react';
import {
  isBrowser,
  isMobileOnly,
  isTablet,
  isLandscape,
  isDesktop,
} from 'react-device-detect';
import { MEControls } from './MEControls';
import styles from './Controls.module.css';
import { WelcomeJourney } from './WelcomeJourney';
import { ReactComponent as Map } from './icon-map.svg';

const Controls = memo(
  ({
    setDataRequested,
    dataRequested,
    navRequired,
    setNavRequired,
    version,
    setContentToDisplay,
    setPageMode,
    handleVersionSwitch,
    MEGSFilteringParameters,
    setMEGSFilteringParameters,
    controlView,
    setControlView,
    welcomeJourneyStep,
    processWelcomeJourney,
  }) => {
    const [incrementAmmount, setIncrementAmmount] = useState({
      incrementBy: 1,
    });
    const container = useRef(null);

    useEffect(() => {
      if (welcomeJourneyStep === 3) {
        setTimeout(() => processWelcomeJourney(welcomeJourneyStep), 1000);
      }
    }, [processWelcomeJourney, welcomeJourneyStep]);

    return (
      <div
        className={styles.controlWrapper}
        style={
          navRequired && (isBrowser || isTablet)
            ? {
                overflowY: 'hidden',
                paddingTop: '350px',
              }
            : {
                display: isLandscape && isMobileOnly ? 'none' : 'block',
              }
        }
      >
        <div
          ref={container}
          className={styles.controlContainer}
          style={{
            // backgroundImage,
            // transition: 'all 1s ease 0s',

            ...(controlView === 'full-screen' ? { position: 'fixed' } : {}),
            height:
              controlView === 'full-screen' || controlView === 'vertical'
                ? '100%'
                : '100px',
            width:
              controlView === 'full-screen' || controlView === 'vertical'
                ? '100%'
                : '100px',
            ...(controlView === 'full-screen' ? { maxWidth: '100%' } : {}),
            overflowY: welcomeJourneyStep < 5 ? 'auto' : 'clip',
            paddingLeft:
              isTablet && controlView === 'full-screen'
                ? 50
                : isDesktop && controlView === 'full-screen'
                ? 200
                : 0,
          }}
        >
          <div
            style={{
              position: 'fixed',
              bottom: 10,
              right: 10,
              color: 'grey',
              display: controlView !== 'full-screen' ? 'none' : 'block',
              ...(isTablet
                ? { width: '60%' }
                : isDesktop
                ? { width: '40%' }
                : {}),
            }}
          >
            <Map width={'100%'} height={'auto'} />
          </div>
          <div
            style={{
              transition: welcomeJourneyStep < 4 ? 'all 1s ease 0s' : '',
              transform:
                welcomeJourneyStep === 3 ? `translateY(-${650}px)` : '',

              ...(isDesktop && controlView === 'full-screen'
                ? { width: 600 }
                : {}),
            }}
          >
            {welcomeJourneyStep < 4 && (
              <WelcomeJourney
                container={container}
                processWelcomeJourney={processWelcomeJourney}
                welcomeJourneyStep={welcomeJourneyStep}
              />
            )}

            {welcomeJourneyStep > 2 && (
              <MEControls
                processWelcomeJourney={processWelcomeJourney}
                welcomeJourneyStep={welcomeJourneyStep}
                incrementAmmount={incrementAmmount}
                controlView={controlView}
                setControlView={setControlView}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
);

// Controls.whyDidYouRender = {
//   logOnDifferentValues: true,
//   customName: 'Menu'
// }

export default Controls;
